//------------------------------------------------------------------------
// Blog filter menu for mobile layout
//------------------------------------------------------------------------
"use strict";
import ExpandToggle from "@threespot/expand-toggle";

export default class FilterMenu {
  constructor(el) {
    this.el = el;

    // Mobile nav toggle setup
    //---------------------------------
    // NOTE: Breakpoint must match $layout-jump-nav-bp in _layout-vars.scss
    this.mediaQueryList = window.matchMedia("(min-width: 1095px)");
    this.toggle = this.el.querySelector(".Filters-toggle");

    // Listen for breakpoint change
    this.mediaQueryList.addListener(evt => {
      if (evt.matches) {
        this.destroyToggle();
      } else {
        this.initToggle();
      }
    });

    // Init on load
    if (!this.mediaQueryList.matches) {
      this.initToggle();
    }
  }

  initToggle() {
    this.toggleExpand = new ExpandToggle(this.toggle);
  }

  destroyToggle() {
    this.toggleExpand.destroy();
  }
}

document.querySelectorAll(".Filters").forEach(el => {
  new FilterMenu(el);
});